import { populate } from 'populate';
import { QuestItemLayout } from 'Layouts/Quests/QuestItemLayout';

const raw = {
    className: 'DefaultQuestsSubLayout',
    width: 640,
    height: 960,
    x: 0,
    y: 0,
    list: [
        {
            id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: 'd583d050-6a79-4962-9d29-904bfe722a96',
            type: 'NineSlicePlane',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 475,
                y: 300,
            },
            width: 950,
            height: 600,
            leftWidth: 102,
            topHeight: 180,
            rightWidth: 92,
            bottomHeight: 141,
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_board',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: 'b22105ef-00a2-4e0b-91eb-d83ad6004ca7',
            type: 'Sprite',
            name: 'closeButton',
            nameSpace: '',
            className: '',
            x: 437,
            y: -263,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: true,
            buttonMode: true,
            hitArea: {
                type: 'None',
            },
            texture: 'btn_close',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: -305,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_title_bg',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: '6011ae22-ba1b-411c-823c-cd3b1ea9cc9f',
            type: 'Sprite',
            name: 'button',
            nameSpace: '',
            className: '',
            x: 0,
            y: 270,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: true,
            buttonMode: true,
            hitArea: {
                type: 'None',
            },
            texture: 'button_medium_orange',
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
        {
            id: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
            type: 'Container',
            name: '',
            nameSpace: '',
            className: '',
            x: 475,
            y: 300,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: 'd583d050-6a79-4962-9d29-904bfe722a96',
            data: '',
        },
        {
            id: '521d513c-5267-46b1-aca4-54a2d58fc64f',
            type: 'Text',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.35,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'Quests',
            localize: true,
            maxWidth: 250,
            maxHeight: 80,
            maxFontSize: 50,
            icons: [],
            style: {
                fontSize: 50,
                fontWeight: 'normal',
                fontFamily: 'MyriadProBlack',
                fill: 'white',
                stroke: '#8d3321',
                strokeThickness: 7,
                align: 'center',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: true,
                dropShadowAlpha: 1,
                dropShadowAngle: 1.3,
                dropShadowBlur: 0,
                dropShadowColor: '#8d3321',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'miter',
                miterLimit: 2,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
            data: '',
        },
        {
            id: 'df9b23c7-988b-4ab8-8db7-0a211f837ffc',
            type: 'Sprite',
            name: '',
            nameSpace: '',
            className: '',
            x: -145,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            tint: 16777215,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            texture: 'mission_title_icon',
            parent: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
            data: '',
        },
        {
            id: 'bd8a8367-5bdb-4dc3-8dd3-945d7a1e4886',
            type: 'Text',
            name: '',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            anchor: {
                x: 0.5,
                y: 0.5,
            },
            scale: {
                x: 1,
                y: 1,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            blendMode: 0,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            text: 'LetsGo',
            localize: true,
            maxWidth: 189,
            maxHeight: 77,
            maxFontSize: 39,
            icons: [],
            style: {
                fontSize: 39,
                fontWeight: 'normal',
                fontFamily: 'FrancoisOne',
                fill: '#FFFFFF',
                stroke: '#9B2813',
                strokeThickness: 6,
                align: 'left',
                wordWrap: false,
                wordWrapWidth: 100,
                breakWords: false,
                lineHeight: 0,
                padding: 5,
                fontStyle: 'normal',
                dropShadow: false,
                dropShadowAlpha: 1,
                dropShadowAngle: 0,
                dropShadowBlur: 0,
                dropShadowColor: 'black',
                dropShadowDistance: 5,
                leading: 0,
                lineJoin: 'miter',
                miterLimit: 2,
                trim: false,
                textBaseline: 'alphabetic',
                whiteSpace: 'pre',
                fontVariant: 'normal',
                letterSpacing: 0,
            },
            parent: '6011ae22-ba1b-411c-823c-cd3b1ea9cc9f',
            data: '',
        },
        {
            id: '8c844442-986f-4361-88d0-0e5a215f8e9e',
            type: 'Layout',
            name: 'quest_item_1',
            nameSpace: '',
            className: 'quests',
            path: 'src/Layouts/Quests/QuestItemLayout.ts',
            percentX: 0,
            percentY: 0,
            x: -290,
            y: -18,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
            data: '',
        },
        {
            id: 'f767b201-0b82-4e38-9fe7-25708c8d36ec',
            type: 'Layout',
            name: 'quest_item_2',
            nameSpace: '',
            className: 'quests',
            path: 'src/Layouts/Quests/QuestItemLayout.ts',
            percentX: 0,
            percentY: 0,
            x: 0,
            y: -18,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
            data: '',
        },
        {
            id: 'e005b4ec-1843-4be5-81a8-f60d46639f4c',
            type: 'Layout',
            name: 'quest_item_3',
            nameSpace: '',
            className: 'quests',
            path: 'src/Layouts/Quests/QuestItemLayout.ts',
            percentX: 0,
            percentY: 0,
            x: 290,
            y: -18,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
            data: '',
        },
    ],
} as const;

export class DefaultQuestsSubLayout {
    static raw = raw;
    root: PIXI.Container;
    quest_item_1: QuestItemLayout;
    quest_item_2: QuestItemLayout;
    quest_item_3: QuestItemLayout;
    closeButton: PIXI.Sprite;
    button: PIXI.Sprite;
    quests: QuestItemLayout[];

    constructor() {
        populate(this, raw);
    }
}
